import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface Props {
  setOpenMenu: (open: boolean) => void;
  menu: boolean;
}

const PayHeader = ({ setOpenMenu, menu }: Props) => {
  const navigate = useNavigate();

  return (
    <Container>
      <Left>
        <img
          src="/assets/images/logo/zipgoai_logo_mobile_header.svg"
          alt=""
          onClick={() => {
            navigate('/');
          }}
        />
      </Left>
      <Right>
        {menu && (
          <img
            src="/assets/images/icon/menu-gray.svg"
            alt=""
            onClick={() => {
              setOpenMenu(true);
            }}
          />
        )}
      </Right>
    </Container>
  );
};

export default PayHeader;

const Container = styled.div`
  width: 100%;
  height: 56px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
  font-family: Spoqa Han Sans Neo;
  max-width: inherit;
`;

const Left = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
`;
const Right = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  cursor: pointer;
`;
const InputBox = styled.div<{ focus?: boolean }>`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0px 8px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  border-radius: ${({ focus }) => (focus ? 'none' : '9999px')};
  border-top-left-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border-top-right-radius: ${({ focus }) => (focus ? '10px' : '9999px')};
  border: ${({ focus }) => (focus ? 'solid 1px #b9b8b8' : 'solid 1px #b9b8b8')};
  background-color: #f7f8fc;
`;

const Input = styled.input`
  width: 100%;
  outline: none;
  border: none;
  background-color: transparent;
`;

const AutoComplete = styled.ul`
  width: 100%;
  position: absolute;
  top: 26px;
  z-index: 9999;
  background-color: #fff;
  border-left: solid 1px #b9b8b8;
  border-right: solid 1px #b9b8b8;
  border-bottom: solid 1px #b9b8b8;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  max-width: inherit;

  li {
    width: 100%;
    padding: 10px;
    border-bottom: solid 1px #b9b8b8;
    list-style: none;

    &:hover {
      background-color: rgb(255, 254, 223);
    }

    &.no-hover {
      &:hover {
        background-color: transparent;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    div > div:first-child {
      flex: 6;
    }

    div > div:nth-child(2) {
      flex: 4;
      justify-content: flex-end;
    }
  }

  :last-child {
    border-bottom: none;
  }
`;

const AutoCompleteText = styled.div<{ color?: string }>`
  display: inline-block;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.color};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const AuctionType = styled.div<{ type: string }>`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: ${(props) =>
    props.type === 'a' ? 'rgb(255, 219, 214)' : 'rgb(222, 237, 255)'};
  color: ${(props) =>
    props.type === 'a' ? 'rgb(216, 72, 54)' : 'rgb(12, 100, 206)'};
  font-weight: 500;
`;
